import api from './api';
import type { Partner } from '../types';

export async function login(email: string, password: string): Promise<{ token: string; partner: Partner }> {
  const { data } = await api.post('/partner/auth/login', { email, password });
  return { token: data.data.accessToken, partner: data.data.partner };
}

export async function logout(): Promise<void> {
  // Revokes the refresh token and clears the cookie — the page can do neither itself.
  await api.post('/partner/auth/logout');
}
